import { Observable, Subject } from 'rxjs';

export class MpSnackbarRef<TComponent = unknown> {
  private readonly _afterClosed = new Subject<void>();

  constructor(private destroyFn: () => void) {}

  dismiss(): void {
    this.destroyFn();
    this._afterClosed.next();
    this._afterClosed.complete();
  }

  public afterClosed(): Observable<void> {
    return this._afterClosed.asObservable();
  }
}
